import React from 'react'
import { StreetGetProps, StreetGetPropsAttributes, useStreet } from './hook'
import { AddressValues } from './utils'

export interface StreetRenderProps {
  ref: React.RefCallback<HTMLInputElement>
  address: AddressValues | undefined
  value?: string
  getProps: (props?: StreetGetPropsAttributes) => StreetGetProps
}

export interface StreetProps {
  children: (props: StreetRenderProps) => React.ReactElement | null
  value?: string
}

const Street = React.memo(({ children, value: defaultValue }: StreetProps) => {
  const { ref, value, address, getProps } = useStreet({
    value: defaultValue,
  })

  return children({
    ref,
    value,
    address,
    getProps,
  })
})

Street.displayName = 'Street'

export { Street }
